module.exports = __webpack_public_path__ + "static/media/fhs-store-locator-inactive.d4a510ae.png";